/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Globo Filter product card AJAX add-to-cart.
  // When the filter is active, Globo re-renders cards from its own cached
  // template (no local Liquid involved), so target `.spf-product__form` —
  // the Globo-exclusive class present in both server-render and filter-render.
  document.addEventListener('submit', (e) => {
    const form = e.target.closest?.('.spf-product__form');
    if (!form) return;
    e.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    if (!button || button.hasAttribute('disabled')) return;

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        bubbles: true,
        detail: { button },
      })
    );
  });

  // Cart drawer "Continue shopping" link. The theme binds only the first
  // [data-cart-drawer-close] it finds, so the link has its own hook and the
  // close (X) button keeps the theme's handler and initial focus.
  document.addEventListener('click', (e) => {
    const backLink = e.target.closest?.('[data-cart-back-link]');
    if (!backLink) return;
    e.preventDefault();
    backLink.closest('cart-drawer')?.closeCartDrawer();
  });

  function globoSearchInput() {
    return document.querySelector('#gf-controls-search-input, .gf-controls-search-input');
  }

  function applyCollectionSearch(value, trigger) {
    const query = String(value || '');
    const gf = globoSearchInput();
    if (gf && gf.value !== query) {
      gf.value = query;
      gf.setAttribute('value', query);
    }

    if (typeof window.searchProducts === 'function') {
      if (trigger) window._collectionSearchTrigger = trigger;
      window.searchProducts(query);
      return true;
    }

    if (!gf) return false;
    gf.dispatchEvent(new Event('input', { bubbles: true }));
    return true;
  }

  function scheduleCollectionSearch(value, trigger) {
    if (applyCollectionSearch(value, trigger)) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (applyCollectionSearch(value, trigger) || attempts > 20) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  function globoFilterTrigger() {
    return document.querySelector(
      '.gf-refine-toggle-mobile button, .gf-refine-toggle-mobile, .gf-open-canvas, [data-toggle-filter]'
    );
  }

  function isSizeValue(value) {
    return /^(xxxs|xxs|xs|s|m|l|xl|xxl|xxxl|2xl|3xl|4xl|5xl|one size|os|\d{2,3})$/i.test(
      String(value || '').trim()
    );
  }

  function reviewCount(badge) {
    const count =
      badge?.getAttribute('data-number-of-reviews') ||
      badge?.querySelector('[data-number-of-reviews]')?.getAttribute('data-number-of-reviews');
    return count == null || count === '' ? null : parseInt(count, 10);
  }

  // Writing the same value still queues a mutation, so only touch `hidden` when it changes
  function setHidden(el, hidden) {
    if (el && el.hidden !== hidden) el.hidden = hidden;
  }

  function syncReviewVisibility(badge) {
    const count = reviewCount(badge);
    const rating = badge.closest('.product-card__rating');
    const hasReviews = count > 0;

    if (count === 0) {
      setHidden(rating, true);
      setHidden(badge, true);
      return { count, hasReviews: false };
    }

    if (hasReviews) {
      setHidden(rating, false);
      setHidden(badge, false);
      return { count, hasReviews: true };
    }

    setHidden(rating, true);
    return { count, hasReviews: false };
  }

  function formatReviewCounts(root) {
    (root || document).querySelectorAll('.jdgm-prev-badge, .jdgm-preview-badge').forEach((badge) => {
      const { count, hasReviews } = syncReviewVisibility(badge);
      if (!hasReviews || count == null) return;
      if (!badge.closest('.collection-products-cro, #gf-products')) return;

      const text = badge.querySelector('.jdgm-prev-badge__text');
      if (!text) return;

      const label = count === 1 ? 'review' : 'reviews';
      const formatted = `(${count} ${label})`;
      if (text.textContent.trim() !== formatted) text.textContent = formatted;
    });
  }

  let judgeMeRetryScheduled = false;

  function renderJudgeMeBadges(badges) {
    if (!badges.length || typeof window.jdgm?.batchRenderBadges !== 'function') return;

    badges.forEach((badge) => badge.setAttribute('data-judgeme-loading', ''));
    window.jdgm.batchRenderBadges(
      badges.map((badge) => ({
        productHandle: badge.dataset.handle,
        badgePlaceholder: badge,
      }))
    );
  }

  function injectGloboReviews(root) {
    (root || document).querySelectorAll('.spf-product-card').forEach((card) => {
      const info = card.querySelector('.spf-product__info');
      const title = info?.querySelector('.spf-product-card__title, .h4');
      if (!info || !title) return;

      info.querySelectorAll('.product-card__stars').forEach((stars) => stars.remove());

      let rating = card.querySelector('.product-card__rating');
      if (!rating) {
        rating = document.createElement('div');
        rating.className = 'product-card__rating';
        rating.hidden = true;
        title.before(rating);
      }

      if (!rating.querySelector('.jdgm-preview-badge')) {
        const href =
          title.querySelector('a')?.getAttribute('href') ||
          card.querySelector('a.spf-product-card__image-wrapper, a[href*="/products/"]')?.getAttribute('href') ||
          '';
        const handle = href.match(/\/products\/([^/?#]+)/)?.[1];
        if (handle) {
          const badge = document.createElement('div');
          badge.className = 'jdgm-widget jdgm-preview-badge';
          badge.setAttribute('data-handle', handle);
          rating.appendChild(badge);
        }
      }
    });

    const pendingBadges = Array.from(
      (root || document).querySelectorAll(
        '.spf-product-card .jdgm-preview-badge[data-handle]:not([data-judgeme-loading])'
      )
    ).filter((badge) => !badge.querySelector('[data-number-of-reviews]'));

    if (pendingBadges.length && typeof window.jdgm?.batchRenderBadges === 'function') {
      renderJudgeMeBadges(pendingBadges);

      if (!judgeMeRetryScheduled) {
        judgeMeRetryScheduled = true;
        const retryUnresolvedBadges = (attempt = 0) => {
          window.setTimeout(() => {
            const scope = root?.isConnected === false ? document : root || document;
            const unresolved = Array.from(
              scope.querySelectorAll('.spf-product-card .jdgm-preview-badge[data-handle]')
            ).filter((badge) => !badge.querySelector('[data-number-of-reviews]'));

            if (!unresolved.length) return;
            unresolved.forEach((badge) => badge.removeAttribute('data-judgeme-loading'));
            renderJudgeMeBadges(unresolved);
            if (attempt < 5) retryUnresolvedBadges(attempt + 1);
          }, 5000);
        };
        retryUnresolvedBadges();
      }
    } else if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      window.jdgm.customizeBadges();
    }
    formatReviewCounts(root);
    window.setTimeout(() => formatReviewCounts(root), 400);
    window.setTimeout(() => formatReviewCounts(root), 1200);
  }

  function injectGloboSizeChips(root) {
    (root || document).querySelectorAll('.spf-product-card').forEach((card) => {
      if (card.querySelector('[data-card-sizes]')) return;

      const existing = card.querySelector('.spf-product__swatchs');
      if (existing) {
        const labels = Array.from(
          existing.querySelectorAll('.spf-product__swatch-text, .spf-product__swatch[title]')
        ).map((el) => (el.textContent || el.getAttribute('title') || '').trim());
        if (labels.length && labels.every(isSizeValue)) return;
        existing.hidden = true;
      }

      const select = card.querySelector('select.spf-product__variants');
      const info = card.querySelector('.spf-product__info');
      if (!select || !info) return;

      const options = Array.from(select.options);
      const groups = [1, 2, 3]
        .map((index) => {
          const values = [];
          options.forEach((opt) => {
            const value = opt.getAttribute(`data-option${index}`);
            if (value && !values.includes(value)) values.push(value);
          });
          return { index, values };
        })
        .filter((group) => group.values.length > 1);

      const sizeGroup =
        groups.find((group) => group.values.filter(isSizeValue).length >= 2) || groups[0];
      if (!sizeGroup) return;

      const wrap = document.createElement('div');
      wrap.className = 'product-card__sizes';
      if (sizeGroup.values.filter(isSizeValue).length < 2) wrap.classList.add('product-card__sizes--text');
      wrap.setAttribute('data-card-sizes', '');

      const selected = select.selectedOptions[0];
      sizeGroup.values.forEach((value) => {
        const available = options.find(
          (opt) =>
            opt.getAttribute(`data-option${sizeGroup.index}`) === value &&
            opt.getAttribute('data-available') !== 'false'
        );
        const any = options.find(
          (opt) => opt.getAttribute(`data-option${sizeGroup.index}`) === value
        );
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-card__size';
        btn.setAttribute('data-card-size', '');
        btn.setAttribute('data-variant-id', (available || any)?.value || '');
        btn.setAttribute('aria-label', value);
        btn.textContent = value;
        if (selected && selected.getAttribute(`data-option${sizeGroup.index}`) === value) {
          btn.classList.add('is-selected');
        }
        if (!available) {
          btn.classList.add('is-unavailable');
          btn.disabled = true;
        }
        wrap.appendChild(btn);
      });

      info.appendChild(wrap);
    });
  }

  function injectLimitedStockBadge(root) {
    return;
  }

  // Globo renders the card's add-to-cart from product.available, but a size filter can preselect a
  // sold-out variant. Match the button to the selected variant, as Globo's own swatch clicks already do.
  function syncGloboAtcState(root) {
    (root || document).querySelectorAll('.spf-product__form').forEach((form) => {
      const option = form.querySelector('select.spf-product__variants')?.selectedOptions[0];
      const button = form.querySelector('.spf-product__form-btn-addtocart');
      if (!option || !button) return;
      const available = option.getAttribute('data-available') !== 'false';
      const label = button.getAttribute(available ? 'data-available' : 'data-soldout');
      const text = button.querySelector('span') || button;
      if (button.disabled === !available && (!label || text.textContent === label)) return;
      button.disabled = !available;
      if (label) text.textContent = label;
    });
  }

  function overlayNativeQuickAdd(root) {
    (root || document).querySelectorAll('.product-item').forEach((item) => {
      const atc = item.querySelector('.product-item__atc');
      const image = item.querySelector('.product-item__image');
      if (!atc || !image || atc.parentElement === image) return;
      image.appendChild(atc);
    });
  }

  function overlayGloboQuickAdd(root) {
    (root || document).querySelectorAll('.spf-product-card').forEach((card) => {
      const form = card.querySelector('.spf-product__form');
      const inner = card.querySelector('.spf-product-card__inner');
      if (!form || !inner || form.parentElement === inner) return;
      inner.appendChild(form);
    });
  }

  function adoptGloboControls() {
    const toolbar = document.querySelector('[data-collection-toolbar]');
    if (!toolbar) return;

    const filterHost = toolbar.querySelector('[data-collection-toolbar-filter]');
    const sortHost = toolbar.querySelector('[data-collection-toolbar-sort]');
    const searchHost = toolbar.querySelector('[data-collection-search]');
    const fallbackFilter = filterHost?.querySelector('[data-collection-filter-btn]');
    const fallbackSort = sortHost?.querySelector('[data-collection-sort-btn]');
    const movedFilter = filterHost?.querySelector('.gf-refine-toggle-mobile');
    const nativeFilterHost = document.querySelector('.gf-actions .gf-filter-trigger');
    const gfSearchForm = document.querySelector('.gf-controls-search-form');
    const searchFallback = searchHost?.querySelector('[data-collection-search-fallback]');

    if (searchHost && gfSearchForm && !searchHost.contains(gfSearchForm)) {
      searchHost.appendChild(gfSearchForm);
    }
    if (searchFallback) searchFallback.hidden = Boolean(searchHost?.querySelector('.gf-controls-search-form'));

    if (movedFilter && nativeFilterHost) nativeFilterHost.appendChild(movedFilter);

    if (fallbackFilter) {
      fallbackFilter.hidden = false;
    }

    if (fallbackSort) fallbackSort.hidden = false;

    document.querySelectorAll('.limit-by').forEach((el) => {
      el.setAttribute('hidden', '');
    });
  }

  function styleGloboFilterHeading() {
    document.querySelectorAll('#gf-filter-title, .gf-filter-heading').forEach((el) => {
      if (el.textContent.trim() === 'Filters') return;
      el.textContent = 'Filters';
    });
  }

  function applyCollectionSort(sortValue) {
    if (!sortValue) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function expandGloboFilters() {
    document.querySelectorAll('#gf-tree .gf-option-block.is-collapsed').forEach((block) => {
      block.classList.remove('is-collapsed');
      block
        .querySelector('.gf-block-title .h3, .gf-block-title h3')
        ?.setAttribute('aria-expanded', 'true');
    });
    document.querySelectorAll('#gf-tree .gf-block-show-more:not(.is-expand)').forEach((el) => {
      el.classList.add('is-expand');
    });
    document.querySelectorAll('#gf-tree li.is-collapsed').forEach((li) => {
      li.classList.remove('is-collapsed');
      const nested = li.querySelector(':scope > ul');
      if (nested) nested.style.display = '';
    });
  }

  const FIGMA_CATEGORIES = [
    { label: 'Hoodies', match: ['hoodies'] },
    { label: 'Pants', match: ['pants'] },
    { label: 'Shirts', match: ['shirts'] },
    { label: 'Sweatshirts', match: ['sweatshirts'] },
    { label: 'T-Shirts', match: ['t-shirts', 't shirts', 'tshirts'] },
    { label: 'Tank tops', match: ['tank tops', 'tank-tops'] },
    { label: 'Underwear', match: ['underwear'] },
    { label: 'All Tops', match: ['all tops', 'clothing tops', 'shirts & tops'] },
  ];

  function normalizeFilterLabel(text) {
    return String(text || '')
      .replace(/\(\s*\d+\s*\)/g, '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function figmaCategoryIndex(text) {
    const normalized = normalizeFilterLabel(text);
    return FIGMA_CATEGORIES.findIndex((category) => category.match.includes(normalized));
  }

  function isProductTypeBlock(block) {
    const title = normalizeFilterLabel(
      block.querySelector('.gf-block-title .h3, .gf-block-title h3')?.textContent
    );
    const type = normalizeFilterLabel(block.getAttribute('data-filter-type'));
    const id = block.getAttribute('data-filter-id') || '';
    return (
      id === '687934' ||
      title === 'product type' ||
      title === 'producttype' ||
      type === 'product type' ||
      type.includes('product type') ||
      type.includes('product_type') ||
      type.includes('producttype')
    );
  }

  function hideGloboProductType() {
    document.querySelectorAll('#gf-tree .gf-option-block').forEach((block) => {
      if (!isProductTypeBlock(block)) return;
      block.setAttribute('data-figma-hide', 'product-type');
      block.hidden = true;
      block.style.setProperty('display', 'none', 'important');
    });
  }

  function limitGloboCategories() {
    hideGloboProductType();
    document.querySelectorAll('#gf-tree [data-filter-type="Category"]').forEach((block) => {
      if (block.hasAttribute('data-figma-hide')) return;
      const title = block.querySelector('.gf-block-title .h3, .gf-block-title h3');
      const titleText = title?.textContent?.trim() || '';
      if (/product\s*type/i.test(titleText)) {
        block.setAttribute('data-figma-hide', 'product-type');
        block.hidden = true;
        block.style.display = 'none';
        return;
      }

      const list = block.querySelector('ul');
      if (!list) return;

      // Several Globo options can map to one category (e.g. "All Tops" and "Clothing Tops"). Keep the
      // item chosen on the previous run: picking the first in DOM order flip-flopped after every
      // reorder, and each reorder re-ran this layout, looping forever.
      const items = Array.from(list.querySelectorAll(':scope > li'));
      const chosen = new Map();
      items.forEach((item) => {
        const index = figmaCategoryIndex(item.querySelector('.gf-label')?.textContent || item.textContent);
        if (index < 0) return;
        if (!chosen.has(index) || item.hasAttribute('data-figma-category')) chosen.set(index, item);
      });

      const matched = new Map();
      items.forEach((item) => {
        const label = item.querySelector('.gf-label');
        const index = figmaCategoryIndex(label?.textContent || item.textContent);
        if (index < 0 || chosen.get(index) !== item) {
          item.removeAttribute('data-figma-category');
          item.hidden = true;
          item.style.display = 'none';
          return;
        }

        item.setAttribute('data-figma-category', '');
        matched.set(index, item);
        item.hidden = false;
        item.style.display = '';
        if (label) {
          const targetLabel = FIGMA_CATEGORIES[index].label;
          if (normalizeFilterLabel(label.textContent) !== normalizeFilterLabel(targetLabel)) {
            const count = label.querySelector('.gf-count');
            label.textContent = targetLabel;
            if (count) label.appendChild(count);
          }
        }
      });

      const orderedItems = FIGMA_CATEGORIES.map((_, index) => matched.get(index)).filter(Boolean);
      const currentItems = Array.from(list.querySelectorAll(':scope > li')).filter(
        (item) => !item.hidden
      );
      const orderChanged = orderedItems.some((item, index) => currentItems[index] !== item);
      if (orderChanged) orderedItems.forEach((item) => list.appendChild(item));
    });
  }

  function restoreNativeGloboFilters() {
    document
      .querySelectorAll('#gf-tree [data-figma-material], #gf-tree [data-figma-size]')
      .forEach((block) => {
        if (block.querySelector('[data-figma-material-value], [data-figma-size-value]')) {
          block.remove();
        } else {
          block.removeAttribute('data-figma-material');
          block.removeAttribute('data-figma-size');
          block.removeAttribute('data-figma-material-fallback');
          block.removeAttribute('data-figma-size-fallback');
        }
      });

    document.querySelectorAll('#gf-tree .gf-option-block').forEach((block) => {
      block.hidden = false;
      block.style.removeProperty('display');
      block.removeAttribute('data-figma-hide');
      block.removeAttribute('data-figma-material');
      block.removeAttribute('data-figma-size');
    });

    document.querySelectorAll('#gf-tree .gf-option-block li').forEach((item) => {
      item.hidden = false;
      item.style.removeProperty('display');
    });
  }

  function applyFigmaNativeFilterLayout() {
    const contents = document.querySelector(
      '#gf-tree .gf-filter-contents-inner, #gf-tree .gf-filter-contents'
    );
    if (!contents) return;

    const blocks = Array.from(contents.querySelectorAll('.gf-option-block'));
    const findBlock = (names) =>
      blocks.find((block) => {
        const type = normalizeFilterLabel(block.getAttribute('data-filter-type'));
        const title = normalizeFilterLabel(
          block.querySelector('.gf-block-title .h3, .gf-block-title h3')?.textContent
        );
        return names.some((name) => type.includes(name) || title === name);
      });

    const category = blocks.find((block) => {
      const type = normalizeFilterLabel(block.getAttribute('data-filter-type'));
      const title = normalizeFilterLabel(
        block.querySelector('.gf-block-title .h3, .gf-block-title h3')?.textContent
      );
      const id = block.getAttribute('data-filter-id') || '';
      return type.includes('category') && title !== 'product type' && id !== '687934';
    });
    const price = findBlock(['price']);
    const size = blocks.find((block) => {
      const type = normalizeFilterLabel(block.getAttribute('data-filter-type'));
      const title = normalizeFilterLabel(
        block.querySelector('.gf-block-title .h3, .gf-block-title h3')?.textContent
      );
      return (
        !isProductTypeBlock(block) &&
        (title === 'size' ||
          title === 'sizes' ||
          type === 'size' ||
          type === 'sizes' ||
          /(^|\s)sizes?$/.test(title) ||
          /(^|\s)sizes?$/.test(type))
      );
    });
    const availability = findBlock(['availability']);
    const percentSale = findBlock(['percent sale']);
    const nativeColor = findBlock(['color', 'colour']);
    const nativeMaterial = findBlock(['material', 'fabric']);

    const restrictSizes = (block) => {
      if (!block) return;
      const sizeAliases = {
        xs: ['xs', 'xsmall', 'extrasmall'],
        s: ['s', 'small'],
        m: ['m', 'medium'],
        l: ['l', 'large'],
        xl: ['xl', 'xlarge', 'extralarge'],
      };
      const labels = { xs: 'XS', s: 'S', m: 'M', l: 'L', xl: 'XL' };
      const matched = new Map();

      Array.from(block.querySelectorAll('ul > li')).forEach((item) => {
        const label = item.querySelector('.gf-label');
        const value = normalizeFilterLabel(label?.textContent || item.textContent).replace(
          /[^a-z0-9]/g,
          ''
        );
        const key = Object.keys(sizeAliases).find((name) => sizeAliases[name].includes(value));
        const show = Boolean(key) && !matched.has(key);
        item.hidden = !show;
        item.style.display = show ? '' : 'none';
        if (!show) return;

        matched.set(key, item);
        if (label && normalizeFilterLabel(label.textContent) !== key) {
          const count = label.querySelector('.gf-count');
          label.textContent = labels[key];
          if (count) label.appendChild(count);
        }
      });

      const orderedItems = ['xs', 's', 'm', 'l', 'xl']
        .map((key) => matched.get(key))
        .filter(Boolean);
      const list = block.querySelector('ul');
      if (!list) return;
      // Re-append only when the order is wrong: every append is a mutation in #gf-tree, which re-runs
      // the filter layout, so an unconditional reorder looped forever on desktop.
      const currentItems = Array.from(list.querySelectorAll(':scope > li')).filter(
        (item) => !item.hidden
      );
      const orderChanged = orderedItems.some((item, index) => currentItems[index] !== item);
      if (orderChanged) orderedItems.forEach((item) => list.appendChild(item));
    };

    if (category) {
      limitGloboCategories();
      category.hidden = false;
      category.style.display = '';
      category.removeAttribute('data-figma-hide');
    }

    restrictSizes(size);
    if (size) {
      size.setAttribute('data-figma-size', '');
      size.classList.add('gf-option-block-box-rectangle');
      size.hidden = false;
      size.style.removeProperty('display');
    }

    if (availability) {
      Array.from(availability.querySelectorAll('ul > li')).forEach((item) => {
        const label = normalizeFilterLabel(
          item.querySelector('.gf-label')?.textContent || item.textContent
        );
        const show = label === 'in stock' || label === 'on sale';
        item.hidden = !show;
        item.style.display = show ? '' : 'none';
      });

      const availabilityOptions = availability.querySelector('ul');
      const hasOnSale = Array.from(availability.querySelectorAll('li')).some(
        (item) =>
          !item.hidden &&
          normalizeFilterLabel(item.querySelector('.gf-label')?.textContent || item.textContent) ===
            'on sale'
      );
      if (!hasOnSale && availabilityOptions && percentSale) {
        const saleOption =
          Array.from(percentSale.querySelectorAll('li')).find((item) =>
            /sale/i.test(item.querySelector('.gf-label')?.textContent || item.textContent)
          ) || percentSale.querySelector('li');
        if (saleOption && saleOption.parentElement !== availabilityOptions) {
          const label = saleOption.querySelector('.gf-label');
          if (label) label.textContent = 'On Sale';
          availabilityOptions.appendChild(saleOption);
        } else if (!availability.querySelector('[data-figma-on-sale]')) {
          const minInput = percentSale.querySelector('.gf-range-min');
          const selected = Number(minInput?.value || minInput?.getAttribute('data-value') || 0) > 0;
          const item = document.createElement('li');
          item.innerHTML =
            '<button type="button" role="checkbox" aria-checked="' +
            String(selected) +
            '" class="' +
            (selected ? 'checked' : '') +
            '" data-figma-on-sale><span class="gf-Checkbox"></span><span class="gf-label">On Sale</span></button>';
          availabilityOptions.appendChild(item);
        }
      }
    }

    const ordered = [category, price, size, availability].filter(Boolean);
    blocks.forEach((block) => {
      const keep = ordered.includes(block);
      block.hidden = !keep;
      block.style.display = keep ? '' : 'none';
      if (!keep) block.setAttribute('data-figma-hide', 'extra-filter');
    });

    if (nativeColor) nativeColor.setAttribute('data-figma-hide', 'waiting-globo');
    if (nativeMaterial) nativeMaterial.setAttribute('data-figma-hide', 'waiting-globo');

    const currentOrder = Array.from(contents.querySelectorAll('.gf-option-block')).filter((block) =>
      ordered.includes(block)
    );
    const orderChanged = ordered.some((block, index) => currentOrder[index] !== block);
    if (orderChanged) ordered.forEach((block) => contents.appendChild(block));

    hideGloboProductType();
  }

  function initCollectionEnhancements() {
    const root = document.querySelector('.collection-products-cro, #gf-products, .collection-products');
    if (!root) return;

    const runCards = () => {
      overlayNativeQuickAdd(root);
      overlayGloboQuickAdd(root);
      injectGloboReviews(root);
      injectGloboSizeChips(root);
      injectLimitedStockBadge(root);
      syncGloboAtcState(root);
    };

    const runFilters = () => {
      adoptGloboControls();
      styleGloboFilterHeading();
      expandGloboFilters();
      applyFigmaNativeFilterLayout();
      hideGloboProductType();
    };

    runCards();
    runFilters();

    let cardScheduled = false;
    let filterScheduled = false;
    const observer = new MutationObserver((mutations) => {
      const treeMutated = mutations.some((mutation) => {
        const node = mutation.target;
        return node.id === 'gf-tree' || node.closest?.('#gf-tree');
      });
      if (treeMutated && !filterScheduled) {
        filterScheduled = true;
        window.setTimeout(() => {
          filterScheduled = false;
          runFilters();
        }, 120);
      }
      if (!cardScheduled) {
        cardScheduled = true;
        window.requestAnimationFrame(() => {
          cardScheduled = false;
          runCards();
        });
      }
    });
    observer.observe(root, { childList: true, subtree: true });
    observer.observe(document.body, { childList: true, subtree: false });
    const tree = document.getElementById('gf-tree');
    if (tree && !root.contains(tree)) observer.observe(tree, { childList: true, subtree: true });
  }

  document.addEventListener('input', (e) => {
    const input = e.target.closest?.('[data-collection-search-input]');
    if (!input) return;
    scheduleCollectionSearch(input.value, 'keystroke');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const input = e.target.closest?.('[data-collection-search-input]');
    if (!input) return;
    e.preventDefault();
    scheduleCollectionSearch(input.value, 'enter');
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest?.('[data-collection-search], .collection-toolbar__search .gf-controls-search-form');
    if (!form) return;

    e.preventDefault();
    const value =
      form.querySelector('[data-collection-search-input], #gf-controls-search-input, .gf-controls-search-input')
        ?.value || '';
    scheduleCollectionSearch(value, 'enter');
  });

  document.addEventListener(
    'click',
    (e) => {
      const onSaleBtn = e.target.closest?.('[data-figma-on-sale]');
      if (!onSaleBtn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const selected = onSaleBtn.classList.contains('checked');
      const saleBlock = Array.from(document.querySelectorAll('#gf-tree .gf-option-block')).find(
        (block) => normalizeFilterLabel(block.getAttribute('data-filter-type')) === 'percent sale'
      );
      const filterId = saleBlock?.getAttribute('data-filter-id');
      const maxInput = saleBlock?.querySelector('.gf-range-max');
      const max = Number(
        maxInput?.getAttribute('data-max-value') ||
          maxInput?.value ||
          saleBlock?.querySelector('.gf-range-slider')?.getAttribute('data-max') ||
          100
      );
      if (!filterId) return;

      const url = new URL(window.location.href);
      const parameter = `filter.${filterId}`;
      if (selected) url.searchParams.delete(parameter);
      else url.searchParams.set(parameter, `1:${max}`);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    },
    true
  );

  document.addEventListener('click', (e) => {
    const sizeBtn = e.target.closest?.('[data-card-size]');
    if (sizeBtn && !sizeBtn.disabled) {
      e.preventDefault();
      const group = sizeBtn.closest('[data-card-sizes]');
      const card = sizeBtn.closest('.product-card, .product-item, .spf-product-card');
      const variantId = sizeBtn.getAttribute('data-variant-id');
      group?.querySelectorAll('[data-card-size]').forEach((btn) => {
        btn.classList.toggle('is-selected', btn === sizeBtn);
      });
      const idInput = card?.querySelector('form input[name="id"]');
      if (idInput && variantId) idInput.value = variantId;
      const select = card?.querySelector('select.spf-product__variants, select[name="id"]');
      if (select && variantId) {
        select.value = variantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const gridToggle = e.target.closest?.('[data-collection-grid-toggle]');
    if (gridToggle) {
      const collectionSection = gridToggle.closest('.collection-products-cro');
      const singleColumn = collectionSection?.classList.toggle('collection-products--single-column');
      gridToggle.setAttribute('aria-pressed', String(Boolean(singleColumn)));
      return;
    }

    const filterBtn = e.target.closest?.('[data-collection-filter-btn]');
    if (filterBtn) {
      e.preventDefault();
      if (typeof window.globofilter?.toggleCanvas === 'function') {
        window.globofilter.toggleCanvas();
        return;
      }
      const trigger = globoFilterTrigger();
      if (trigger && trigger !== filterBtn && !filterBtn.contains(trigger)) {
        trigger.click();
        return;
      }
      const tree = document.querySelector('#gf-tree, .gf-left, .gf-filter-contents');
      if (tree) tree.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const sortBtn = e.target.closest?.('[data-collection-sort-btn]');
    if (sortBtn) {
      e.preventDefault();
      const menu = sortBtn
        .closest('[data-collection-toolbar-sort]')
        ?.querySelector('[data-collection-sort-menu]');
      const opening = Boolean(menu?.hidden);
      document.querySelectorAll('[data-collection-sort-menu]').forEach((item) => {
        item.hidden = true;
      });
      document.querySelectorAll('[data-collection-sort-btn]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
      if (menu && opening) {
        menu.hidden = false;
        sortBtn.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    const sortOption = e.target.closest?.('[data-collection-sort-value]');
    if (sortOption) {
      e.preventDefault();
      document.querySelectorAll('[data-collection-sort-menu]').forEach((menu) => {
        menu.hidden = true;
      });
      document.querySelectorAll('[data-collection-sort-btn]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
      applyCollectionSort(sortOption.getAttribute('data-collection-sort-value'));
      return;
    }

    document.querySelectorAll('[data-collection-sort-menu]').forEach((menu) => {
      menu.hidden = true;
    });
    document.querySelectorAll('[data-collection-sort-btn]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  });

  function initIconTextMarquee() {
    document.querySelectorAll('[data-icon-text-marquee]').forEach((section) => {
      const track = section.querySelector('.icon-text-section__track');
      if (!track || track.dataset.marqueeReady === 'true') return;
      track.dataset.marqueeReady = 'true';

      const restart = () => {
        track.style.animation = 'none';
        void track.offsetWidth;
        track.style.animation = '';
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) restart();
        });
      });
      observer.observe(section);
    });
  }

  function initCardEnhancements() {
    initCollectionEnhancements();
    formatReviewCounts(document);
    initIconTextMarquee();

    const reviewObserver = new MutationObserver(() => formatReviewCounts(document));
    reviewObserver.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-number-of-reviews'],
    });
    document.addEventListener('jdgm.doneInitializing', () => {
      document
        .querySelectorAll('.spf-product-card .jdgm-preview-badge[data-judgeme-loading]')
        .forEach((badge) => {
          if (!badge.querySelector('[data-number-of-reviews]')) {
            badge.removeAttribute('data-judgeme-loading');
          }
        });
      injectGloboReviews(document);
      formatReviewCounts(document);
    });
  }

  function headerSearchInputs() {
    return document.querySelectorAll(
      'header-search-popdown input[type="search"], .search-popdown input[type="search"], .mobile-search-form input[type="search"]'
    );
  }

  function hideGloboSearchPopup() {
    document.querySelectorAll('#glFilter-search-popup, .glFilter-search-popup').forEach((popup) => {
      popup.hidden = true;
      popup.style.setProperty('display', 'none', 'important');
    });
  }

  function unbindGloboHeaderSearch() {
    const $ = window.jQuery;
    headerSearchInputs().forEach((input) => {
      if (!$ || !$(input).data('ui-autocomplete')) return;
      try {
        $(input).autocomplete('destroy');
      } catch (err) {}
    });
    hideGloboSearchPopup();
  }

  function isMobileHeaderSearch() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function resetSearchPopdownLayout(pop) {
    if (!pop) return;
    ['position', 'top', 'left', 'right', 'width', 'height', 'max-width', 'transform', 'z-index', 'padding-right'].forEach((prop) => {
      pop.style.removeProperty(prop);
    });
  }

  function clearBodyScrollPadding() {
    if (!isMobileHeaderSearch()) return;
    document.body.style.setProperty('padding-right', '0px', 'important');
    document.documentElement.style.setProperty('padding-right', '0px', 'important');
  }

  function layoutMobileSearchBar(details) {
    const pop = details?.querySelector('.search-popdown');
    const header = document.querySelector('.header__mobile');
    if (!pop) return;

    if (!details.open || !isMobileHeaderSearch() || !header) {
      resetSearchPopdownLayout(pop);
      return;
    }

    clearBodyScrollPadding();

    const headerRect = header.getBoundingClientRect();
    const hostRect = (details.closest('header-search-popdown') || pop).getBoundingClientRect();

    pop.style.setProperty('position', 'fixed', 'important');
    pop.style.setProperty('top', '0px', 'important');
    pop.style.setProperty('left', '0px', 'important');
    pop.style.setProperty('right', 'auto', 'important');
    pop.style.setProperty('padding-right', '0px', 'important');
    pop.style.setProperty(
      'transform',
      `translate(${-hostRect.left}px, ${headerRect.bottom - hostRect.top}px)`,
      'important'
    );
    pop.style.setProperty('width', '100vw', 'important');
    pop.style.setProperty('max-width', '100vw', 'important');
    pop.style.setProperty('height', `${headerRect.height}px`, 'important');
    pop.style.setProperty('z-index', '7000', 'important');
    clearBodyScrollPadding();
    window.setTimeout(clearBodyScrollPadding, 0);
    window.setTimeout(clearBodyScrollPadding, 50);
  }

  document.addEventListener(
    'toggle',
    (e) => {
      const details = e.target.closest?.('.header__mobile header-search-popdown details, header-search-popdown details');
      if (!details) return;
      if (!details.open) {
        resetSearchPopdownLayout(details.querySelector('.search-popdown'));
        document.body.style.removeProperty('padding-right');
        document.documentElement.style.removeProperty('padding-right');
        return;
      }
      unbindGloboHeaderSearch();
      const input = details.querySelector('input[type="search"]:not([type="hidden"])');
      window.requestAnimationFrame(() => {
        unbindGloboHeaderSearch();
        layoutMobileSearchBar(details);
        input?.focus();
      });
    },
    true
  );

  window.addEventListener('resize', () => {
    document.querySelectorAll('.header__mobile header-search-popdown details[open]').forEach((details) => {
      layoutMobileSearchBar(details);
    });
  });

  document.addEventListener('focusin', (e) => {
    if (!e.target.closest?.('header-search-popdown, .search-popdown, .mobile-search-form')) return;
    unbindGloboHeaderSearch();
  });

  const globoSearchObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (
          node.id === 'glFilter-search-popup' ||
          node.classList.contains('glFilter-search-popup') ||
          node.querySelector?.('#glFilter-search-popup, .glFilter-search-popup')
        ) {
          hideGloboSearchPopup();
          return;
        }
      }
    }
  });
  globoSearchObserver.observe(document.documentElement, { childList: true, subtree: true });
  unbindGloboHeaderSearch();
  window.addEventListener('load', unbindGloboHeaderSearch);

  function mobileMenuPane() {
    return document.querySelector('.drawer--header [data-sliderule-pane]');
  }

  function resetMobileMenuPane() {
    const pane = mobileMenuPane();
    if (pane) pane.setAttribute('data-sliderule-pane', '0');
  }

  function restoreMobileMenuRows() {
    document.querySelectorAll('.drawer--header .sliderow.is-hidden, .drawer--header .sliderow.is-hiding').forEach((row) => {
      row.classList.remove('is-hidden', 'is-hiding');
    });
  }

  function closeMobileMenuPanel(panel) {
    if (!panel) return;
    panel.classList.remove('is-visible', 'is-hiding');
    panel.querySelectorAll('.is-visible, .is-hiding, .is-hidden').forEach((el) => {
      el.classList.remove('is-visible', 'is-hiding', 'is-hidden');
    });
    restoreMobileMenuRows();
    resetMobileMenuPane();

    const trigger = document.querySelector(`[data-sliderule-open="${panel.id}"]`);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function openMobileMenuPanel(panel) {
    document.querySelectorAll('.drawer--header .sliderule__panel.is-visible').forEach((openPanel) => {
      if (openPanel === panel || openPanel.contains(panel)) return;
      closeMobileMenuPanel(openPanel);
    });

    panel.classList.add('is-visible');
    panel.classList.remove('is-hiding');
    restoreMobileMenuRows();
    resetMobileMenuPane();

    const trigger = document.querySelector(`[data-sliderule-open="${panel.id}"]`);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener(
    'click',
    (e) => {
      const trigger = e.target.closest?.('[data-sliderule-open]');
      if (!trigger || !trigger.closest('.drawer--header')) return;

      const panel = document.getElementById(trigger.getAttribute('data-sliderule-open'));
      if (!panel) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      if (panel.classList.contains('is-visible')) {
        closeMobileMenuPanel(panel);
      } else {
        openMobileMenuPanel(panel);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (e) => {
      const closeBtn = e.target.closest?.('[data-sliderule-close]');
      if (!closeBtn || !closeBtn.closest('.drawer--header')) return;

      const panel = document.getElementById(closeBtn.getAttribute('data-sliderule-close'));
      if (!panel) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      closeMobileMenuPanel(panel);
    },
    true
  );

  document.addEventListener('theme:sliderule:close', () => {
    document.querySelectorAll('.drawer--header .sliderule__panel.is-visible, .drawer--header .sliderule__panel.is-hiding').forEach((panel) => {
      closeMobileMenuPanel(panel);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardEnhancements);
  } else {
    initCardEnhancements();
  }

  // PDP size guide tooltip: hover shows it via CSS, tap/click pins it (touch has no hover)
  const closeSizeGuideTips = (except) => {
    for (const tip of document.querySelectorAll('[data-size-guide-tip].is-open')) {
      if (tip === except) continue;
      tip.classList.remove('is-open');
      tip.querySelector('.size-guide-tip__button')?.setAttribute('aria-expanded', 'false');
    }
  };

  document.addEventListener('click', (e) => {
    const button = e.target.closest?.('.size-guide-tip__button');
    const tip = button?.closest('[data-size-guide-tip]');
    closeSizeGuideTips(tip);
    if (!tip) return;

    const isOpen = tip.classList.toggle('is-open');
    button.setAttribute('aria-expanded', String(isOpen));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSizeGuideTips();
  });

  // Broadcast's collapsible-elements strips `open` on init, so "Open by default" never sticks
  customElements.whenDefined('collapsible-elements').then(() => {
    for (const details of document.querySelectorAll('details[data-collapsible][data-default-open]')) {
      details.closest('collapsible-elements')?.open?.(details);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
